import { render } from "./CustomList.vue?vue&type=template&id=3dd543b0"
import script from "./CustomList.vue?vue&type=script&lang=js"
export * from "./CustomList.vue?vue&type=script&lang=js"

import "./CustomList.vue?vue&type=style&index=0&id=3dd543b0&lang=scss"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__